<div class="marv_sub_item">
    <ng-content></ng-content>
</div>